import { Component } from 'react'
import { Auth, API } from 'aws-amplify'
import withRouter from './components/withRouter'
import Routes from './routes'
import Logo from './images/hit_logo.png'
import './App.css'


class App extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isAuthenticated: false,
      isLoadingBackground: true,
      isSplashScreen: false,
      user: null,
      loadingCss: 'App-Loading-Bar-Init',
      loadedCss: 'App-Faded',
      back: [],
      myLoc: null,
      data: null,
      options: null,
      mode: 'Home'
    }

    this.handleLogout = this.handleLogout.bind(this)
  }

  componentDidMount() {
    Auth.currentAuthenticatedUser()
      .then(() => {
        this.setState({ isAuthenticated: true })
        API.get('hit', 'user')
          .then(resp => {
            this.setState({
              loadingCss: 'App-Loading-Bar-Final',
              user: resp.data || null
            })
          })
          .catch(e => {
            //this.handleLogout()
            this.setState({ isAuthenticated: false, user: null })
          })
      })
      .catch(e => {
        console.log(e)
        this.setState({ isAuthenticated: false, user: null })
      })
    setTimeout(() => this.setState({ loadingCss: 'App-Loading-Bar-Post', isSplashScreen: true }), 230)
    setTimeout(() => this.setState({ isLoadingBackground: false, loadedCss: 'App-Showing' }), 500)
    setTimeout(() => this.setState({ isSplashScreen: false }), 2500)
  }

  userHasAuthenticated = authenticated => this.setState({ isAuthenticated: authenticated, isSplashScreen: false })
  setUser = user => this.setState({ user })
  onBack = (refresh) => this.handleBack(refresh)
  addHistory = path => this.handleAddHistory(path)
  onMyLoc = myLoc => this.setState({ myLoc })
  setData = data => this.setState({ data })
  setOptions = options => this.setState({ options })
  setMode = mode => this.setState({ mode })
  async handleLogout() {
    if (this.state.isAuthenticated) {
      try {
        await Auth.signOut({ global: true })
        this.setState({ user: null, data: null })
        this.userHasAuthenticated(false)
        const { navigate } = this.props
        navigate('/')
      } catch (e) {
        console.log(e.message)
      }
    }
  }

  handleGiglocaScreen() {
    this.setState({ isSplashScreen: false })
  }

  handleAddHistory(path) {
    let back = [...this.state.back]
    back.push(path)
    this.setState({ back })
  }

  handleBack(refresh) {
    //stack 'back' values LIFO
    const { navigate } = this.props
    let back = this.state.back ? [...this.state.back] : []
    let goto = back.length > 0 ? back.splice(back.length - 1, 1) : ['/']
    this.setState({ back })
    navigate(`${goto[0]}${refresh ? '?refresh=true' : ''}`)
  }

  render() {
    const childProps = {
      isAuthenticated: this.state.isAuthenticated,
      userHasAuthenticated: this.userHasAuthenticated,
      setUser: this.setUser,
      user: this.state.user,
      onBack: this.onBack,
      onAddHistory: this.addHistory,
      onLogout: this.handleLogout,
      onMyLoc: this.onMyLoc,
      myLoc: this.state.myLoc,
      data: this.state.data,
      setData: this.setData,
      options: this.state.options,
      setOptions: this.setOptions,
      setMode: this.setMode,
      mode: this.state.mode
    }
    //console.log(this.state)
    return (
      !this.state.isLoadingBackground ?
        <div>
          {
            this.state.isSplashScreen ? <div className='HIT-Container'>
              <div className='HIT-Title' onClick={() => this.handleGiglocaScreen()}>HIT FHIR App</div>
              <div className='All-Splash'><img src={Logo} className='All-Logo' alt="HIT FHIR" /></div>
            </div> :
              <Routes childProps={childProps} />
          }
        </div> :
        <div className="App-Loading">
          <div className={`App-Loading-Bar ${this.state.loadingCss}`}></div>
        </div>
    )
  }
}

export default withRouter(App);
